import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ArticleDisciplineService {

  private api_url = environment.apiUrl + '/ArticleDiscipline';

  constructor(private http: HttpClient) { }

  post(discipline: any) {
    return this.http.post(`${this.api_url}`, discipline);
  }

  update(discipline: any) {
    return this.http.put(`${this.api_url}`, discipline);
  }

  get(articleKey: number): Observable<any> {
    return this.http.get(`${this.api_url}/All?articleKey=${articleKey}`);
  }

  delete(key: number) {
    return this.http.delete(`${this.api_url}/${key}`);
  }

}
